<template>
<div id="vy_body">
  <div id="vy_grid">
    <div id="vy_left_nav" class="p-4">
    </div>
    <div id="vy_main">
      <main>
       <br><br><br>
       <b>契約期間が終了いたしましたので、ご利用いただけません。</b>
      </main>
    </div>
    
    <div id="vy_right_nav" class="p-4">
        <!--右サイドバー-->
    </div>
  </div>
</div>
</template>

<script setup>
/* eslint-disable */
import ShakyoHome from './ShakyoHome.vue'
import ShakyoInputCSV from './ShakyoInputCSV.vue'
import ShakyoLeftbar from './ShakyoLeftBar.vue'
import ShakyoRightBar from './ShakyoRightBar.vue'
import FooterArea from '../common/FooterArea.vue'
import { GlobalData, login_check } from '../js/userdata_shakyo.js';
import { useRouter, useRoute } from 'vue-router'
import { shallowRef, watch } from 'vue'
import axios from 'axios'
const url = GlobalData.$API_URL
const content = shallowRef('')
const router = useRouter();
const route = useRoute();
let param = {}

</script>
